export const HAIRLINE = 'rgb(237,238,239)';
export const BORDER = 'rgb(215,215,215)';
export const SURFACE_HOVER = 'rgb(245,245,245)';
